<div *ngFor="let accordionSection of additionalAccordianSections; let i = index">
  <div class="accordion card">
    <div class="card-header">
      <h4 (click)="toggleCollapsed(i)" class="flex-text">
        <div [ngClass]="getArrowIcons(i)" class="arrow-icon">
          {{ accordionSection.title }}
        </div>
      </h4>
    </div>
    <div [ngClass]="getAccordionStyle(i)" class="collapsible card-body">
      <div class="collapsible card-body" [innerHTML]="accordionSection.body || '' | mdToHtml"></div>
      <!-- <app-prism-xml [xmlData]="additionalAccordianSections.xmlDataArray"></app-prism-xml> -->
      <div [innerHTML]="accordionSection.subBody || '' | mdToHtml"></div>
    </div>
  </div>
</div>
